<app-saved-search-form [saveSearchForm]="saveSearchForm" (submitForm)="submit()"></app-saved-search-form>
